import React, { Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as RegionsActions } from 'store/ducks/regions';

import { Page, Breadcrumbs } from 'components';
import { Form } from 'pages/Regions/components';

class Create extends Component {
  state = {
    data: {
      name: '',
      places: [],
    },

    breadcrumbs: [
      { name: 'Home', to: '/' },
      { name: 'Regiões', to: '/regions' },
      { name: 'Novo', to: '' },
    ],
  };

  handleChange = data => {
    this.setState({ form: data });
  };

  handleSubmit = e => {
    e.preventDefault();

    const { form } = this.state;
    const { createRegionRequest } = this.props;

    createRegionRequest({
      region: {
        name: form.name,
        place_ids: form.places.map(place => place.value),
      }
    });
  };

  render() {
    const { data, breadcrumbs } = this.state;
    const { create } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form data={data} saving={create.loading} onChange={this.handleChange} onSubmit={this.handleSubmit} />
      </Page>
    );
  }
}

const mapState = state => ({
  create: state.regions.create,
});

const mapActions = dispatch => bindActionCreators(RegionsActions, dispatch);

export default connect(mapState, mapActions)(Create);
